import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';

import{ArticleService} from '../../services/article.service';

declare var $:any;//Required for jquery use

@Component({
  selector: 'app-manage-country-group',
  templateUrl: './manage-country-group.component.html',
  styleUrls: ['./manage-country-group.component.css']
})
export class ManageCountryGroupComponent implements  OnInit,IRule {

  groupid:number = 0;
	userName='';
	navigationsType=[];

  url:any=AppSettings.API_ENDPOINT;

	type_articles:any=[];

	msg:any;

	toastr:any;

	_router:any;

	record_empty:number =0;

  record_offset:number = 0;
	

	token:any='';

  templateGroupList = [];

  searchTxt:string = '';

  per_page:number=10;

  groupId:number=0;
  groupAddTxt:string = '';
  groupOldTxt:string = '';
  groupInputLabel:string = 'Add New';
  
  loader_image:boolean =true

  notification:any=[];

  countryList=[];
  country= [
    {key:'Australia',value:'Australia'},
    {key:'Austria',value:'Austria'},
    {key:'Bahrain',value:'Bahrain'},
    {key:'Belgium',value:'Belgium'},
    {key:'Bosnia & Herzegovina',value:'Bosnia & Herzegovina'},
    {key:'Bulgaria',value:'Bulgaria'},
    {key:'Canada',value:'Canada'},
    {key:'Croatia',value:'Croatia'},
    {key:'Cyprus',value:'Cyprus'},
    {key:'Czech Republic',value:'Czech Republic'},
    {key:'Denmark',value:'Denmark'},
    {key:'Estonia',value:'Estonia'},
    {key:'Finland',value:'Finland'},
    {key:'France',value:'France'},
    {key:'Germany',value:'Germany'},
    {key:'Greece',value:'Greece'},
    {key:'Hungary',value:'Hungary'},
    {key:'Iceland',value:'Iceland'},
    {key:'India',value:'India'},
    {key:'Ireland',value:'Ireland'},
    {key:'Israel',value:'Israel'},
    {key:'Italy',value:'Italy'},
    {key:'Japan',value:'Japan'},
    {key:'Latvia',value:'Latvia'},
    {key:'Lithuania',value:'Lithuania'},
    {key:'Luxembourg',value:'Luxembourg'},
    {key:'Macedonia',value:'Macedonia'},
    {key:'Malaysia',value:'Malaysia'},
    {key:'Malta',value:'Malta'},
    {key:'Moldova',value:'Moldova'},
    {key:'Netherlands',value:'Netherlands'},
    {key:'New Zealand',value:'New Zealand'},
    {key:'Norway',value:'Norway'},
    {key:'Palestine',value:'Palestine'},
    {key:'Phillipines',value:'Phillipines'},
    {key:'Poland',value:'Poland'},
    {key:'Portugal',value:'Portugal'},
    {key:'Qatar',value:'Qatar'},
    {key:'Montenegro',value:'Montenegro'},
    {key:'Serbia',value:'Serbia'},
    {key:'Romania',value:'Romania'},
    {key:'Russia',value:'Russia'},
    {key:'Saudi Arabia',value:'Saudi Arabia'},
    {key:'Slovakia',value:'Slovakia'},
    {key:'Slovenia',value:'Slovenia'},
    {key:'South Africa',value:'South Africa'},
    {key:'Spain',value:'Spain'},
    {key:'Sweden',value:'Sweden'},
    {key:'Switzerland',value:'Switzerland'},
    {key:'Thailand',value:'Thailand'},
    {key:'Turkey',value:'Turkey'},
    {key:'Ukraine',value:'Ukraine'},
    {key:'United Arab Erimates',value:'United Arab Erimates'},
    {key:'United Kingdom',value:'UK'},
    {key:'United States of America',value:'United States of America'}
    
    ];
    
  selectedCountry = [];
  oldSelectedCountry=[]
  dropdownSettings3 = {};


  @HostBinding('style.width') public width: string = '100%'; //for edge browser design issue

  constructor(msg:MessageService, toastr: ToastrService, _router: Router,private articleService:ArticleService) { 
  	this.msg = msg;
    this.toastr = toastr;
    this._router =_router;
  }

  ngOnInit() {

    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

     let arr=[]
    this.country.map((x)=>{
      let obj={}
      obj['key']=x.key.toUpperCase()
      obj['value']= x.value
      arr.push(obj)
    })
    this.countryList=arr

  	try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        limit:this.per_page,
        'page':'settings'
      }
      this.loader_image =true
      this.groupList(data);


    }catch(error){

      this._router.navigate(['/login']);

    }
  }

  groupLazyList(offset)
  {
    
   

    let data={
      token:this.token,
      search:this.searchTxt,
      limit:this.per_page,
      offset:offset,
      'page':'settings'
      
    }
   
  this.loader_image =true
  this.record_empty =1;
  this.groupList(data);

  }

  ngAfterViewInit(){

  	//for lazy load
  	$(window).on("scroll", function() {  


      if(this._router.url == '/settings/manage-user-group'){


        if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {       


           if(this.record_empty == 0){

              this.record_offset+=this.per_page;

             

              this.groupLazyList(this.record_offset);

            }          

        }

      }


    }.bind(this));

  	$(document).ready(function(){
  		$('input').blur(function(event) {
            var inputValue = this.value;
            if (inputValue) {
                this.classList.add('value-exists');
            } else {
                this.classList.remove('value-exists');
            }
        });

        $('a.tooltip-custom').click(function(){
        		$('.approver-popup > input ').addClass('value-exists');
        });

        $('body').on('click','.tooltip-custom',function(){

         	$(this).tooltip("hide");

       	 });


	       let tl:any= $('body');
	         tl.tooltip({
	          trigger: "hover" ,
	          selector: '.tooltip-custom'
	      });

	      tl.on('show.bs.tooltip', () => {
	        //$('.tooltip-custom').not(this).remove();
	      });

	      //scrolltotop
	      $(window).scroll(function(){
				if ($(this).scrollTop() > 1) {
					$('#yt-totop').css({bottom:"25px"});
				} else {
				$('#yt-totop').css({bottom:"-50px"});
				}
			});
			
			$('#yt-totop').click(function(){
				$('html, body').animate({scrollTop: '0px'}, 800);
					return false;
			});

  	}.bind(this));
  }

  groupList(data)
  {
  	
  		this.articleService.getCountryGroup(data).subscribe( (res)=>{

        
        if(res.status=='success'){
          
          this.loader_image =false

          if(res.groups !=undefined ){

            this.record_empty = 0;

          } else{

           this.record_empty =1;

          }

          if(this.templateGroupList.length==0){
            // if(res.department !=undefined ){
            //   this.templateGroupList=res.department;
            // }else{
            //   this.templateGroupList=[]
            // }  
            this.templateGroupList=res.groups;

          } else if(res.groups !=undefined ){
            
            res.groups.forEach(element => {

              this.templateGroupList.push(element);
              
            });

          }


          this.userName=res.user.name;

          this.navigationsType=res.navigation;

          this.notification =res.notification;

            
          this.broadcast_menu();

        }else{        
          this.toastr.error(res.message, '', {timeOut: 5000});
        }
    });

  }


  searchGroupType()
  {
  	let data={
        token:this.token,
        search:this.searchTxt,
        limit:this.per_page,
        'page':'settings'
      }
     
    this.loader_image =true
    this.templateGroupList=[];
    this.record_offset=0;
    this.groupList(data);
     

  }

  deleteTemplateGroup(){

    let data={
      token:this.token,
      reqData:{
        id:this.groupid, 
        archive:true,
        'page':'settings'
      }
     
      //offset:this.record_offset
    }


    this.articleService.removeUserGroup(data).subscribe( (res)=>{
            

      if(res.status=='success'){

        let catI = this.templateGroupList.findIndex( (elm) => { return  elm.id ==  this.groupid});
          
        this.templateGroupList.splice(catI,1);

        this.groupid =0;


      }else{
        this.groupid =0;
      }

    });


  }

  deletetGroupList(gid){

   

    this.groupid = gid;

    
    $('#success-popup').modal('show');

  }


  onCountrySelect($event){

  }

  onCountrySelectAll($event){

  }

  onCountryDeSelect($event){

  }

  onCountryDeSelectAll($event){

  }

  addGroupType()
  {
    let msg = "";

    
   //&& (this.groupOldTxt.trim() != this.groupAddTxt.trim())

  	if (this.groupAddTxt.trim() != ''  && this.selectedCountry.length>0) {
      let country=[]
      // this.oldSelectedCountry.map((x)=>{
      //   country.push(x)
      // })
      this.selectedCountry.map((x)=>{
        if(x.value!=undefined){
          country.push(x.value)
        }else{
          country.push(x)
        }
         
      })

		let data={
			token:this.token,
      group:this.groupAddTxt,
      countries:country,
      limit:this.per_page,
      'page':'settings'
			//offset:this.record_offset
		}
		msg =  'Country group added successfully';
		if(this.groupId > 0 && this.groupInputLabel == 'Edit')
			{
        let id ;
        id =this.groupId
				data = Object.assign(data, {'id' : parseInt(id)});
        msg = 'Country group updated successfully';
        
        let catI = this.templateGroupList.findIndex( (elm) => { return  elm.id == this.groupId});
          
        this.templateGroupList[catI].group= this.groupAddTxt;
        this.templateGroupList[catI].countries= this.selectedCountry



      } 
      this.groupAddTxt = ''; 
      this.selectedCountry = [];
	    this.groupInputLabel = 'Add New ';  
	    // this.typeId = 0; 
      this.loader_image =true
      // console.log('data',data)
      this.articleService.countryGroup(data).subscribe( (res)=>{

        if(res.status=='success'){
          this.toastr.success(msg, '', {timeOut: 5000}); 

          let data={
            token:this.token,
            limit:this.per_page,
            'page':'settings'
          }
          this.templateGroupList=[];
          this.groupList(data);
        }
      })
	    // this.groupList(data);
	    
	    // this.toastr.success(msg, '', {timeOut: 5000}); 

	    //hide the popup after successfull addition
	    $('#create_template_country_popup').modal('hide');
    }else{
    	msg = 'Field can not be blank / same !';
		 this.toastr.error(msg, '', {timeOut: 5000});
    }

  }

  editGroupList(id:number,val:any)
  {

  	this.groupAddTxt = val.group;
    this.groupOldTxt = val.group;
    this.groupId = id;
    this.groupInputLabel = 'Edit'; 
    // this.selectedCountry = val.countries
    this.oldSelectedCountry = val.countries
    let country=[]
    val.countries.map((x)=>{
      let obj={}
      obj['key'] =x.toUpperCase()
      obj['value']=x
      country.push(obj)
    })

    this.selectedCountry = country

    //show the popup after successfull addition
	$('#create_template_country_popup').modal('show');

  }

   broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
   }  


  

}